import { StatusStates } from '../../constants/status.constants';

export const isAcceptedDateVisible = (
  status: string,
  acceptedDate?: string,
): boolean => status === StatusStates.Confirmed && Boolean(acceptedDate);
